'use client';

import { useCallback, useEffect } from 'react';
import {
  notifyPublicSearchSyncQueued,
  registerPublicSearchSyncListener,
} from '@/lib/publicSearchSyncNotifier';

export function usePublicSearchSyncNotifications(userGuid?: string) {
  useEffect(() => {
    registerPublicSearchSyncListener(userGuid);
  }, [userGuid]);

  const notifyQueued = useCallback(
    (syncMessageId?: string | null) => {
      notifyPublicSearchSyncQueued(userGuid, syncMessageId);
    },
    [userGuid],
  );

  return { notifyQueued };
}
